<lta-svg-icon class="close-icon" *ngIf="withCloseBtn" icon="close" size="20" (click)="onClose.emit()"></lta-svg-icon>
<ng-content></ng-content>
